import React from 'react';
import { Stack, Button, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import LoadingButton from '@mui/lab/LoadingButton';

const useStyles = makeStyles(() => ({
    buttonContent: {
        margin: '16px 8px 0',
        //width: '250px',
        //float: 'right'
    },
    loadingSpace: {
        // width: '100%',
        justifyContent: 'space-between',
    },
    loadingCenter: {
        // width: '100%',
        justifyContent: 'center',
        // color: '#00000042!important'
    },
    buttonCenter: {
        //width: '100%',
        justifyContent: 'center',
    }
}));

const ButtonContainer = (props) => {
    const classes = useStyles();

    return (
        <Stack
            spacing={2}
            direction="row-reverse"
            className={!props.isSocialResponsibility ? classes.buttonContent : ""}
        >
            {props.showLoading ? (
                <LoadingButton
                    onClick={props.handleClick}
                    loading={props.loading}
                    loadingPosition="center"
                    variant="contained"
                    disabled={
                        props.disableUpdateButton != false && props.disableUpdateButton != undefined
                            ? props.disableUpdateButton
                            : props.disableButton != undefined
                                ? props.disableButton
                                : false
                    }
                    className={classes.loadingCenter}
                    sx={{
                        width: props.buttonText !== 'Update & Submit' ? "100px !important"
                            : "160px !important", marginTop: "-2px"
                    }}
                >
                    {props.buttonText}
                </LoadingButton>
            ) : (
                <Button
                    type="submit"
                    variant="contained"
                    onClick={props.handleClick ? props.handleClick : null}
                    disabled={
                        props.disableUpdateButton != false && props.disableUpdateButton != undefined
                            ? props.disableUpdateButton
                            : props.disableButton != undefined
                                ? props.disableButton
                                : false
                    }
                    className={classes.buttonCenter}
                    sx={{
                        width: props.buttonText !== 'Update & Submit' ? "100px !important"
                            : "160px !important", marginTop: "-2px"
                    }}>
                    {props.buttonText}
                </Button>
            )
            }

            {
                props.showSaveAsDraftBtn ? (
                    <Button
                        variant="outlined"
                        onClick={props.handleSaveAsDraft}
                        disabled={(props.disableDraftBtn || props.saveAsDraftLoader)}
                        className={classes.buttonCenter}
                        sx={{ width: "160px !important" }}>

                        {
                            props.saveAsDraftLoader ? <CircularProgress
                                size={20}
                                color="grey"
                                style={{ position: 'absolute' }}
                            /> : null
                        }
                        Save As Draft
                    </Button>
                ) : null
            }
            <Button
                variant="outlined"
                onClick={props.handleCancel}
                disabled={
                    props.disableCancel != undefined
                        ? props.disableCancel
                        : props.disableButton != undefined
                            ? props.disableButton
                            : false
                }
                sx={{ width: '100px', display: props.hideCancel ? 'none' : '' }}>
                {props.cancelText != undefined ? props.cancelText : 'Cancel'}
            </Button>
        </Stack >
    );
};
export default ButtonContainer;

ButtonContainer.defaultProps = {
    showSaveAsDraftBtn: false,
    handleSaveAsDraft: () => { },
    disableDraftBtn: false,
    saveAsDraftLoader: false
};
